<div *ngIf="mode === 'numberOnly'" [innerHtml]="sum?.result | numberWithLetter"></div>
<div *ngIf="mode !== 'numberOnly'" [class.edit-mode]="editMode" [title]="editMode ? '' : 'CLICK_TO_EDIT_KPI_CALCULATION' | translate">
	<div class="close-layer" *ngIf="editMode" (click)="editMode = false"></div>
	<div class="pane-wrapper">
		<div class="pane-content">
			<button *ngIf="editMode" class="button done-button" (click)="done();editMode = false">
				{{ 'DONE' | translate }}
			</button>
			<div class="pane-title" *ngIf="editMode && kpi">
				<h3>
					{{ kpi?.label }}
				</h3>
			</div>
			<div class="toolbox" *ngIf="editMode">
				<div class="preview-container">
					<a class="preview-link" title="Click to preview"
						(click)="onPreviewLinkClick($event, project?.mainMediaClipId, project?.title)"
						>Preview {{ project?.title }}
					</a>
				</div>
				<div class="toolgroup operators">
					<span class="operator" *ngFor="let part of calculationParts">
						<button *ngIf="part.type ==='operator' || part.type ==='grouping'" class="button" (click)="addPart(part)"
						 [disabled]="isDisabled(part)" [class.disabled]="isDisabled(part)">{{part.label}}</button>
					</span>
					<button class="button" (click)="removeLast()" [disabled]="! mathFieldArr.length" [class.disabled]="! mathFieldArr.length">
						<i class="fa fa-arrow-left"></i> {{ 'BACKSPACE' | translate }}
					</button>
					<button class="button" (click)="clear()" [disabled]="! mathFieldArr.length" [class.disabled]="! mathFieldArr.length">
						<i class="fa fa-ban"></i> {{ 'CLEAR' | translate }}
					</button>
					<button class="button" (click)="groupAll()" [disabled]="! mathFieldArr.length" [class.disabled]="! mathFieldArr.length">
						( ) {{ 'GROUP_ALL' | translate }}
					</button>
				</div>
				<div class="toolgroup variables">
					<ng-container *ngFor="let part of calculationParts">
						<span class="operator" *ngIf="!part.projectLevel">
							<button *ngIf="part.type ==='variable' && part.entity !== 'external'" class="button" (click)="addPart(part)" [disabled]="isDisabled(part)"
							 [class.disabled]="isDisabled(part)">{{part.label}}<span *ngIf="getStats(part)"> ({{ getStats(part) }})</span></button>
							 <button *ngIf="part.type ==='variable' && part.entity === 'external'" class="button" (click)="addPart(part)" [disabled]="isDisabled(part)"
							 [class.disabled]="isDisabled(part)"><i class="fa fa-table"></i>{{part.label}}<span *ngIf="getStats(part)"> ({{ getStats(part) }})</span></button>
						</span>
					</ng-container>
				</div>
			</div>

			<div class="input kpi-input" [class.click-to-edit]="!editMode" (click)="editMode = true">
				<div class="edit-button" *ngIf="!editMode">
					<i class="fa fa-pencil"></i>
				</div>
				<!-- <div>
					<input type="text" name="kpiTest" (input)="mathFieldChanged($event)" [(ngModel)]="mathFieldText" />
				</div> -->
				<div class="calculation-output">
					<em *ngIf="!mathFieldArr || !mathFieldArr.length" class="calculation-part">
						<div class="content">
							{{ (editMode ? 'START_BY_ADDING_A_VARIABLE' : 'CLICK_TO_EDIT_KPI_CALCULATION') | translate }}
						</div>
					</em>
					<div
						*ngFor="let part of mathFieldArr; let ind = index;"
						class="calculation-part"
						[class.hovered]="hoveredMetric === part.entity + part.id + part.property"
						(mouseover)="hoveredMetric = (part.parentEntityType ? part.parentEntityType + part.parentEntityId : '') + part.entity + part.id + part.property"
						(mouseout)="hoveredMetric = ''"
					>
						<div class="content"
							(click)="cursorIndex = ind + 1"
							[style.border-left]="editMode && ind === 0 && cursorIndex === 0 ? '2px solid red' : ''"
							[style.border-right]="editMode && ind + 1 === cursorIndex ? '2px solid red' : ''">
							<div *ngIf="part.type === 'operator' || part.type === 'grouping'" class="operator">
								<span> {{ part.label }} </span>
								<ng-container *ngIf="editMode">
									<br />
									<span class="sum-part"> {{ part.value }} </span>
								</ng-container>
							</div>
							<div *ngIf="part.type === 'variable' && part.entity !== 'number'" class="variable">
								[<i *ngIf="part.icon" class="fa" [ngClass]="'fa-'+part.icon"></i> {{ part.label }}]
								<ng-container *ngIf="editMode && getStats(part)">
									<br />
									<span class="sum-part"> {{ getStats(part) }} </span>
								</ng-container>
							</div>
							<div *ngIf="part.type === 'variable' && part.entity === 'number'" class="variable">
								<span [textContent]="part.value" (input)="numberValChanged($event, part)" contenteditable="true"
								 [class.content-editable-number]="editMode"></span>
								<ng-container *ngIf="editMode && (part.value || part.value === 0)">
									<br />
									<span class="sum-part"> {{ part.value }} </span>
								</ng-container>
							</div>
						</div>
						<div class="remove" (click)="removePart(ind)">
							<i class="fa fa-times"></i>
						</div>
					</div>

				</div>
			</div>
			<div class="total-result" [title]="haveStats ? sum?.evalString : ''" [class.no-stats-available]="!haveStats"
			 [class.error]="!sum?.result && sum?.result !== 0" *ngIf="mathFieldArr && mathFieldArr.length">
				<div *ngIf="editMode || haveStats" class="sum"> 
					{{ calculateSum() }}
					<small *ngIf="goal && !isPercentage" [title]="'PERCENTAGE_OF_GOAL' | translate">
						(
						<span *ngIf="!checkNaN(sum?.result/goal)" [class.green]=" sum?.result>goal" [class.orange]="sum?.result/goal > 0.5 && sum?.result<goal"
						 [class.red]="sum?.result/goal < 0.5 && sum?.result<goal">{{ calculatePercentage() }}</span>
						<span *ngIf="checkNaN(sum?.result/goal)">
							{{ 'NOT_A_NUMBER' | translate }}
						</span>
						)
					</small>
				</div>
				<div *ngIf="!haveStats">
					{{ 'NO_STATISTICS_AVAILABLE' | translate }}
				</div>
			</div>
			<div *ngIf="editMode" class="widget-table-container">
				<div class="table-settings">
					<div class="table-filter">
						<input type="text" placeholder="Filter on widget label"
							[formControl]="tableFilter" name="table_filter" (keydown)="$event.stopPropagation()" />
					</div>
					<div class="kpis-only">
						<label>
							<bb-check [(ngModel)]="showOnlyKPIs" name="showOnlyKPIs" (ngModelChange)="onShowKPIChange($event)" no-dirty></bb-check>
							{{ 'KPIS_ONLY' | translate }}
						</label>
					</div>
				</div>
				<!-- <div class="filters">
					title: <input type="text" [(ngModel)]="filters.title" /> widget label: <input type="text" [(ngModel)]="filters.widget" />
				</div> -->

				<!-- PROJECT -->
				<div class="project-info" [class.has-project-widgets]="projectWidgets?.length">
					<bb-table-container>
						<bb-table-header>
							<bb-table-header-cell [hideSorting]="true">&nbsp;</bb-table-header-cell>
							<bb-table-header-cell [hideSorting]="true" property="id">{{ 'ID' | translate }}</bb-table-header-cell>
							<bb-table-header-cell [hideSorting]="true" property="title">{{ 'PROJECT_TITLE' | translate }}</bb-table-header-cell>
							<bb-table-header-cell [hideSorting]="true" property="metrics">{{ 'METRICS' | translate }}</bb-table-header-cell>
							<bb-table-header-cell *ngIf="projectWidgets?.length" [hideSorting]="true" property="widgets">{{ 'WIDGETS' | translate }}</bb-table-header-cell>
						</bb-table-header>

						<bb-table-row class="widget-row">
							<bb-table-cell class="icon-cell">&nbsp;</bb-table-cell>
							<bb-table-cell property="id">{{ project.id }}</bb-table-cell>

							<bb-table-cell property="title">
								<a class="preview-link" title="Click to preview"
								(click)="onPreviewLinkClick($event, project?.mainMediaClipId, project.title)">
									<span>
										{{ project.title || project.name }}
									</span>
								</a>
							</bb-table-cell>

							<bb-table-cell property="metrics">
								<div class="toolgroup variables">
									<ng-container *ngFor="let part of calculationParts">
										<span class="operator" *ngIf="part.projectLevel">
											<button *ngIf="part.type ==='variable' && part.entity !== 'external'" class="button" (click)="addPart(part)" [disabled]="isDisabled(part)"
											 [class.disabled]="isDisabled(part)">{{part.label}}<span *ngIf="getStats(part)"> ({{ getStats(part) }})</span></button>
											 <button *ngIf="part.type ==='variable' && part.entity === 'external'" class="button" (click)="addPart(part)" [disabled]="isDisabled(part)"
											 [class.disabled]="isDisabled(part)"><i class="fa fa-table"></i>{{part.label}}<span *ngIf="getStats(part)"> ({{ getStats(part) }})</span></button>
										</span>
									</ng-container>
								</div>
							</bb-table-cell>
							<bb-table-cell property="widgets" *ngIf="projectWidgets?.length">
								<div class="pw-col">
									<ng-container *ngIf="projectWidgets && projectWidgets.length">
										<div *ngFor="let widget of projectWidgets" class="widget">
											<span *ngIf="!showOnlyKPIs || (widget.useAsKPI === 'true' || widget.useAsKPI === true)" [hidden]="tableFilter?.value && ! checkSearchValue(widget)">
												<span [innerHTML]="widget.widgetdefinitiontype | widgetIcon"></span>
												<span [attr.title]="widget.label">
													<span>
														{{ widget.label }}
													</span>
													<button
														class="button"
														(mouseover)="hoveredMetric = 'Project' + project?.id + 'widget' + widget.id + 'shows'"
														(mouseout)="hoveredMetric = ''"
														[class.hovered]="hoveredMetric === 'Project' + project?.id + 'widget' + widget.id + 'shows'"
														[class.active]="usedMetricsRef['Project' + project?.id + 'widget' + widget.id + 'shows']"
														(click)="addPart({ type: 'variable', entity: 'widget', value: widget.id, id: widget.id, property: 'shows', label: widget.label, icon: 'eye', parentEntityId: project.id, parentEntityType: 'Project' })"
														[disabled]="isDisabled({ type: 'variable' })"
														[class.disabled]="isDisabled({ type: 'variable' })"
													>
														<i class="fa fa-eye"></i> {{ 'SHOWS' | translate }}
														<span *ngIf="widget.stats?.shows" class="widget-stats">( {{ widget.stats.shows }} )</span>
													</button>
													<button 
														class="button"
														(mouseover)="hoveredMetric = 'Project' + project?.id + 'widget' + widget.id + 'clicks'"
														(mouseout)="hoveredMetric = ''"
														[class.hovered]="hoveredMetric === 'Project' + project?.id + 'widget' + widget.id + 'clicks'"
														[class.active]="usedMetricsRef['Project' + project?.id + 'widget' + widget.id + 'clicks']"
														(click)="addPart({ type: 'variable', entity: 'widget', value: widget.id, id: widget.id, property: 'clicks', label: widget.label, icon: 'hand-pointer-o', parentEntityId: project.id, parentEntityType: 'Project' })"
														[disabled]="isDisabled({ type: 'variable' })"
														[class.disabled]="isDisabled({ type: 'variable' })">
														<i class="fa fa-hand-pointer-o"></i> {{ 'CLICKS' | translate }}
														<span *ngIf="widget.stats?.clicks" class="widget-stats">( {{ widget.stats.clicks }} )</span>
													</button>
												</span>
											</span>
											<ng-container *ngIf="widget && widget.widgets">
												<div *ngFor="let subwidget of widget.widgets" [hidden]="tableFilter?.value && ! checkSearchValue(subwidget)">
													<ng-container *ngIf="!showOnlyKPIs || (subwidget.useAsKPI === 'true' || subwidget.useAsKPI === true)">
														<i class="fa fa-folder-open" title="in-app"></i>
														{{ widget.label }}
														<span [innerHTML]="subwidget.widgetdefinitiontype | widgetIcon"></span>
														<span [attr.title]="subwidget.label">
															{{ subwidget.label }}
															<button
																class="button"
																(mouseover)="hoveredMetric = 'Project' + project?.id + 'widget' + widget.id + 'shows'"
																(mouseout)="hoveredMetric = ''"
																[class.hovered]="hoveredMetric === 'Project' + project?.id + 'widget' + subwidget.id + 'shows'"
																[class.active]="usedMetricsRef['Project' + project?.id + 'widget' + subwidget.id + 'shows']"
																(click)="addPart({ type: 'variable', entity: 'widget', value: subwidget.id, id: subwidget.id, property: 'shows', label: subwidget.label, icon: 'eye', parentEntityId: project.id, parentEntityType: 'MediaClip' })"
																[disabled]="isDisabled({ type: 'variable' })"
																[class.disabled]="isDisabled({ type: 'variable' })"
															>
																<i class="fa fa-eye"></i> {{ 'SHOWS' | translate }}
																<span *ngIf="subwidget.stats?.shows" class="widget-stats">( {{ subwidget.stats.shows }} )</span>
															</button>
															<button
																class="button"
																(mouseover)="hoveredMetric = 'Project' + project?.id + 'widget' + subwidget.id + 'clicks'"
																(mouseout)="hoveredMetric = ''"
																[class.hovered]="hoveredMetric === 'Project' + project?.id + 'widget' + subwidget.id + 'clicks'"
																[class.active]="usedMetricsRef['Project' + project?.id + 'widget' + subwidget.id + 'clicks']"
																(click)="addPart({ type: 'variable', entity: 'widget', value: subwidget.id, id: subwidget.id, property: 'clicks', label: subwidget.label, icon: 'hand-pointer-o', parentEntityId: project.id, parentEntityType: 'MediaClip' })"
																[disabled]="isDisabled({ type: 'variable' })"
																[class.disabled]="isDisabled({ type: 'variable' })"
															>
																<i class="fa fa-hand-pointer-o"></i> {{ 'CLICKS' | translate }}
																<span *ngIf="subwidget.stats?.clicks" class="widget-stats">( {{ subwidget.stats.clicks }} )</span>
															</button>
														</span>
													</ng-container>
												</div>
											</ng-container>
										</div>
									</ng-container>
								</div>
							</bb-table-cell>
						</bb-table-row>
					</bb-table-container>
				</div>

				<!-- MEDIACLIP TABLE -->
				<div [hidden]="tableRows?.length || !tableFilter.value">
					No mediaclip results found
				</div>
				<div class="scrollbar" *ngIf="tableRows && tableRows.length">
					<bb-table-container>

						<bb-table-header>
							<bb-table-header-cell>&nbsp;</bb-table-header-cell>
							<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
							<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
							<bb-table-header-cell [hideSorting]="true" property="views">{{ 'VIEWS' | translate }}</bb-table-header-cell>
							<bb-table-header-cell [hideSorting]="true" property="widgets">{{ 'WIDGETS' | translate }}</bb-table-header-cell>
						</bb-table-header>

						<ng-container *ngFor="let row of tableRows">
							<bb-table-row [row]="row" class="widget-row">
								<bb-table-cell class="icon-cell">&nbsp;</bb-table-cell>
								<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>

								<bb-table-cell property="title">
									<a class="preview-link" title="Click to preview"
									(click)="onPreviewLinkClick($event, row.data.id, row.data.title)">
										<span>
											{{ row.data.title }}
										</span>
									</a>
								</bb-table-cell>

								<bb-table-cell property="views">
									<button
										class="button"
										(mouseover)="hoveredMetric = 'mediaclip' + row.data.id + 'views'"
										(mouseout)="hoveredMetric = ''"
										[class.hovered]="hoveredMetric === 'mediaclip' + row.data.id + 'views'"
										[class.active]="usedMetricsRef['mediaclip' + row.data.id + 'views']"
										(click)="addPart({ type: 'variable', entity: 'mediaclip', value: row.data.id, id: row.data.id, property: 'views', label: row.data.title, icon: 'play' })"
										[disabled]="isDisabled({ type: 'variable' })"
										[class.disabled]="isDisabled({ type: 'variable' })"
									>
										<i class="fa fa-play"></i> {{ 'VIEWS' | translate }}
										<span *ngIf="row.data.stats?.views" class="mc-views">( {{ row.data.stats.views }} )</span>
									</button>
								</bb-table-cell>
								<bb-table-cell property="widgets">
									<ng-container *ngIf="row.data.widgets?.length">
										<div *ngFor="let widget of row.data.widgets; let i = index;" class="widget">
											<span *ngIf="!showOnlyKPIs || (widget.useAsKPI === 'true' || widget.useAsKPI === true)" [hidden]="tableFilter?.value && ! checkSearchValue(widget)">
												<span [innerHTML]="widget.widgetdefinitiontype | widgetIcon"></span>
												<span [attr.title]="widget.label">
													<span>
														{{ widget.label }}
													</span>
													<button
														class="button"
														(mouseover)="hoveredMetric = 'MediaClip' + row.data.id + 'widget' + widget.id + 'shows'"
														(mouseout)="hoveredMetric = ''"
														[class.hovered]="hoveredMetric === 'MediaClip' + row.data.id + 'widget' + widget.id + 'shows'"
														[class.active]="usedMetricsRef['MediaClip' + row.data.id + 'widget' + widget.id + 'shows']"
														(click)="addPart({ type: 'variable', entity: 'widget', value: widget.id, id: widget.id, property: 'shows', label: widget.label, icon: 'eye', parentEntityId: row.data.id, parentEntityType: 'MediaClip' })"
														[disabled]="isDisabled({ type: 'variable' })"
														[class.disabled]="isDisabled({ type: 'variable' })"
													>
														<i class="fa fa-eye"></i> {{ 'SHOWS' | translate }}
														<span *ngIf="widget.stats?.shows" class="widget-stats">( {{ widget.stats.shows }} )</span>
													</button>
													<button 
														class="button"
														(mouseover)="hoveredMetric = 'MediaClip' + row.data.id + 'widget' + widget.id + 'clicks'"
														(mouseout)="hoveredMetric = ''"
														[class.hovered]="hoveredMetric === 'MediaClip' + row.data.id + 'widget' + widget.id + 'clicks'"
														[class.active]="usedMetricsRef['MediaClip' + row.data.id + 'widget' + widget.id + 'clicks']"
														(click)="addPart({ type: 'variable', entity: 'widget', value: widget.id, id: widget.id, property: 'clicks', label: widget.label, icon: 'hand-pointer-o', parentEntityId: row.data.id, parentEntityType: 'MediaClip' })"
														[disabled]="isDisabled({ type: 'variable' })"
														[class.disabled]="isDisabled({ type: 'variable' })">
														<i class="fa fa-hand-pointer-o"></i> {{ 'CLICKS' | translate }}
														<span *ngIf="widget.stats?.clicks" class="widget-stats">( {{ widget.stats.clicks }} )</span>
													</button>
												</span>
											</span>
											<ng-container *ngIf="widget && widget.widgets">
												<div *ngFor="let subwidget of widget.widgets" [hidden]="tableFilter?.value && ! checkSearchValue(subwidget)">
													<ng-container *ngIf="!showOnlyKPIs || (subwidget.useAsKPI === 'true' || subwidget.useAsKPI === true)">
														<i class="fa fa-folder-open" title="in-app"></i>
														{{ widget.label }}
														<span [innerHTML]="subwidget.widgetdefinitiontype | widgetIcon"></span>
														<span [attr.title]="subwidget.label">
															{{ subwidget.label }}
															<button
																class="button"
																(mouseover)="hoveredMetric = 'MediaClip' + row.data.id + 'widget' + widget.id + 'shows'"
																(mouseout)="hoveredMetric = ''"
																[class.hovered]="hoveredMetric === 'MediaClip' + row.data.id + 'widget' + subwidget.id + 'shows'"
																[class.active]="usedMetricsRef['MediaClip' + row.data.id + 'widget' + subwidget.id + 'shows']"
																(click)="addPart({ type: 'variable', entity: 'widget', value: subwidget.id, id: subwidget.id, property: 'shows', label: subwidget.label, icon: 'eye', parentEntityId: row.data.id, parentEntityType: 'MediaClip' })"
																[disabled]="isDisabled({ type: 'variable' })"
																[class.disabled]="isDisabled({ type: 'variable' })"
															>
																<i class="fa fa-eye"></i> {{ 'SHOWS' | translate }}
																<span *ngIf="subwidget.stats?.shows" class="widget-stats">( {{ subwidget.stats.shows }} )</span>
															</button>
															<button
																class="button"
																(mouseover)="hoveredMetric = 'MediaClip' + row.data.id + 'widget' + subwidget.id + 'clicks'"
																(mouseout)="hoveredMetric = ''"
																[class.hovered]="hoveredMetric === 'MediaClip' + row.data.id + 'widget' + subwidget.id + 'clicks'"
																[class.active]="usedMetricsRef['MediaClip' + row.data.id + 'widget' + subwidget.id + 'clicks']"
																(click)="addPart({ type: 'variable', entity: 'widget', value: subwidget.id, id: subwidget.id, property: 'clicks', label: subwidget.label, icon: 'hand-pointer-o', parentEntityId: row.data.id, parentEntityType: 'MediaClip' })"
																[disabled]="isDisabled({ type: 'variable' })"
																[class.disabled]="isDisabled({ type: 'variable' })"
															>
																<i class="fa fa-hand-pointer-o"></i> {{ 'CLICKS' | translate }}
																<span *ngIf="subwidget.stats?.clicks" class="widget-stats">( {{ subwidget.stats.clicks }} )</span>
															</button>
														</span>
													</ng-container>
												</div>
											</ng-container>
											<span class="project-divider" *ngIf="!projectWidgetsRef[widget.id] && projectWidgetsRef[row.data.widgets[i + 1]?.id]">
												<hr />
												<strong>
													Project level widgets
												</strong>
											</span>
										</div>
									</ng-container>
								</bb-table-cell>
							</bb-table-row>
						</ng-container>
					</bb-table-container>
				</div>
			</div>
		</div>
	</div>
</div>
